<template>
  <div class="yfyjsMore">
    <div class="content-wrap">
        <div class="c-inner-title">
            <h2 class="c-inner-title-t">规划与顾问</h2>
            <h3 class="c-inner-title-c">PLANNING &amp; CONSULTING</h3>
        </div>
        <div class="hammer-icon">
            <span class="scrile"></span>
            <span class="icon-map2 icon"></span>
        </div>
        <div class="wrap-nav-second clearfix">
            <router-link to="/listMsg" class="lf every-tit">
                <span class="icon-feather icon"></span>
                <p class="firstp">智慧旅游规划</p>
            </router-link>
            <router-link to="/listMsg" class="lf every-tit">
                <span class="icon-pencil icon"></span>
                <p class="firstp">智慧旅游设计</p>
            </router-link>
            <router-link to="/listMsg" class="lf every-tit">
                <span class="icon-user-tie icon"></span>
                <p class="firstp">顾问和监理</p>
            </router-link>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yfyjsMore',
  data () {
    return {
    
    }
  },
  mounted(){
  },
  methods:{
  }
}
</script>

<style scoped>
.yfyjsMore{width: 100%;height: 100%; background: url(../../assets/images/ghygw_03.png) no-repeat;background-size: cover}
.c-inner-title{text-align: center;font-weight: 400}
.c-inner-title-t{color: #fff;display: block;font-size: .32rem;padding-top: 1.25rem}
.c-inner-title-c{color: #2a9ee7;font-size: .2rem;padding-top: .1rem; }
.every-tit p{font-size: .2rem;color: #fff;width: 83%;margin: 0 auto; line-height: .32rem}
.icon{padding-top: .16rem;display: inline-block;color: #fff}
.every-tit{width: 1.18rem;height: 1.38rem;margin-left: .35rem;margin-bottom: .3rem;-webkit-box-shadow: 0 0 6px rgba(255,255,255,.4); box-shadow: 0 0 6px rgba(255,255,255,.4);background: rgba(73,73,73,.5)}
.content-wrap{width: 78%;margin: 0 auto;}
.wrap-nav-second{margin-top: .9rem}
.hammer-icon{width:1.25rem;height:1.3rem;background: url(../../assets/images/icon-cz.png) no-repeat;background-size: 100%;margin:0 auto;margin-top: .26rem;position: relative;}
.scrile{width: .14rem;height: .14rem;background: #fff;border-radius: 50%;position: absolute;left: 50%;top: -.05rem;}
.icon-map2{color:#2a9ee7; font-size: .6rem;}
.icon-map2:before {
    display: inline-block;
    padding-top: .15rem
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/ghygwMore.vue